import React from 'react';

const VientiRivi = ({data, detailed}) => {
  let sum, credit, debit, vatSum, vatCredit, vatDebit;

  if (!detailed) {
    sum = Math.abs(data.SUMMA + data.ALVSUMMA).toFixed(2);
  } else {
    sum = Math.abs(data.SUMMA).toFixed(2);
    vatSum = Math.abs(data.ALVSUMMA).toFixed(2);
  }

  if (data.SUMMA >= 0) {
    debit = sum;
    vatDebit = vatSum;
  } else if (data.SUMMA < 0) {
    credit = sum;
    vatCredit = vatSum;
  }

  return (
    <tbody className="vientirivi">
      <tr>
        <td className="text-overflow" colSpan="3">
          <span className="inforow-title">{data.SELITE}</span>
        </td>
      </tr>

      <tr>
        <td className="text-overflow inset">
          <span className="inforow-title text-overflow">
            <span className="profitrow-accountnumber">{data.TILINRO} </span>
            {data.NIMIFI}
          </span>
        </td>
        <td className="text-right color-green">
          {debit}
        </td>
        <td className="text-right color-red">
          {credit}
        </td>
      </tr>

      {
        detailed &&
        data.ALVTILI ?
        <tr>
          <td className="inset">
            <span className="inforow-title">
              <span className="profitrow-accountnumber">{data.ALVTILI} </span>
              {data.ALVNIMI}
            </span>
          </td>
          <td className="text-right color-green">
            {vatDebit}
          </td>
          <td className="text-right color-red">
            {vatCredit}
          </td>
        </tr> :
        null
      }
    </tbody>
  );
};

export default VientiRivi;
